const checkWeight = () =>{
    const labels = document.querySelectorAll('.product-single__weight-label');
    const inputs = document.querySelectorAll('.product-single__weight-input');
    inputs.forEach(input => input.addEventListener('change', (e) =>{
        checkNewCheckbox(labels, e.currentTarget.nextElementSibling);
        calculatePriceByWeightAndQuantity();
    }))
}

const checkNewCheckbox = (labels, checkbox) => {
    labels.forEach(label => 
        label.classList.contains('product-single__weight-label--checked') &&
        label.classList.remove('product-single__weight-label--checked')
    );
    checkbox.classList.add('product-single__weight-label--checked');
}

const calculatePriceByWeightAndQuantity = () => {
    const checkedWeightValue = +Array
        .from(document.querySelectorAll('.product-single__weight-input'))
        .find(input => input.checked).value;
    let quantity = +document.querySelector('.qty').value;
    if(!quantity) {
        quantity = 1;
        document.querySelector('.qty').value = quantity;
    }
    const basePrice = +document.querySelector('.product-single__price-based').innerText;
    const currentPrice = parseFloat(Math.round(((basePrice * checkedWeightValue * quantity) * 100)) / 100).toFixed(2);
    const currentPricePlaceholder = document.querySelector('.product-single__price-calculated');
    currentPricePlaceholder.innerText = currentPrice;
}

const calculatePriceOnQuantityChange = () => {
    const quantityInput = document.querySelector('.qty');
    quantityInput.addEventListener('change', () => calculatePriceByWeightAndQuantity())
}

const changeQuantityInput = (changeValue) => {
    const quantityInput = document.querySelector('.product-single__quantity-input');
    ['.product-single__quantity-increase', '.product-single__quantity-decrease'].forEach((btn, index) => {
        document.querySelector(btn).addEventListener('click', (e) => {
            e.preventDefault();
            quantityInput.value = +quantityInput.value + changeValue[index];
            calculatePriceByWeightAndQuantity();
        })
    })
}


if(document.querySelector('.product-single__weight')){
    calculatePriceByWeightAndQuantity();
    calculatePriceOnQuantityChange();
    checkWeight();
    changeQuantityInput([1, -1]);
}